import {
  Box,
  Divider,
  Flex,
  HStack,
  IconButton,
  Image,
  Link,
  SimpleGrid,
  Spacer,
  Stack,
  Text,
  useMediaQuery,
  VStack,
} from '@chakra-ui/react';
import { APPSTORE_URL, PLAYSTORE_URL } from '@diamond/shared/environments';
import styled from '@emotion/styled';
import NextLink from 'next/link';

import pacakgeInfo from '../../../../../package.json';
import { footerLinks, socialMedias, socialMediasInterface } from './properties';

const PageContainer = styled.div`
  max-width: 1536px;
  margin: 0px auto;
`;

function Footer() {
  const [isMobile] = useMediaQuery('(min-width: 768px)');
  const imagePath = isMobile
    ? '/images/sukanda_logo_UB.png'
    : '/images/sukanda_logo_LR.png';

  const year = new Date().getFullYear();

  return (
    <Box id="footer" w="100%" px={{ base: 4 }}>
      <PageContainer>
        <Stack pb={{ base: 8, md: 9 }} mt={10}>
          <Flex
            direction={{
              base: 'column',
              sm: 'column',
              md: 'column',
              lg: 'row',
            }}
          >
            <HStack>
              <Image
                src={imagePath}
                alt="Sukanda Onelink Logo"
                width={{ base: '150px', md: '115px' }}
                height={{ base: '28px', md: '105px' }}
              />
              <Spacer display={{ base: 'none', md: 'block' }} w="40px" />
              <Stack direction={{ base: 'row', md: 'column' }}>
                <Link href={APPSTORE_URL} target="_blank">
                  <Image
                    src="/images/sukanda-onelink-app-store.png"
                    alt="Sukanda Onelink Appstore Logo"
                    width={{ base: '90px', md: '153px' }}
                    height={{ base: '28px', md: '45px' }}
                  />
                </Link>
                <Link href={PLAYSTORE_URL} target="_blank">
                  <Image
                    src="/images/sukanda-onelink-playstore.png"
                    alt="Sukanda Onelink Playstore Logo"
                    width={{ base: '90px', md: '153px' }}
                    height={{ base: '28px', md: '45px' }}
                  />
                </Link>
              </Stack>
            </HStack>
            <Divider
              my={4}
              display={{ base: 'block', sm: 'block', md: 'block', lg: 'none' }}
            />
            <Spacer
              my={4}
              display={{ base: 'none', sm: 'none', md: 'none', lg: 'block' }}
            />
            <HStack>
              {socialMedias.map((item: socialMediasInterface, index) => (
                <NextLink key={index} href={item.url} target="_blank">
                  <IconButton
                    key={index}
                    color="blue"
                    variant="outline"
                    size="lg"
                    aria-label={item.label}
                    icon={<item.icon />}
                  />
                </NextLink>
              ))}
            </HStack>
          </Flex>
          <Divider orientation="horizontal" pt={{ base: 2, md: 8 }} />
          <SimpleGrid
            columns={{ base: 1, md: 4 }}
            spacing={4}
            py={{ base: 4, md: 6 }}
          >
            {footerLinks.map((item, index) => (
              <Text
                key={index}
                as={Link}
                bg={'transparent'}
                textAlign={{ base: 'left', md: 'center' }}
                _hover={{ bg: 'transparent', textColor: 'cyan' }}
                style={{ textDecoration: 'none' }}
                href={item.url}
                isExternal={item.isExternal}
              >
                {item.label}
              </Text>
            ))}
          </SimpleGrid>
          <Divider />
          <VStack py={8} spacing={4}>
            <Text
              fontSize={{ base: 'sm', md: 'md' }}
              maxW="2xl"
              textAlign="center"
            >
              Sukanda OneLink adalah aplikasi e-commerce B2B yang mudah
              digunakan untuk membantu Anda memesan dan mengelola semua
              kebutuhan F&B Anda di Sukanda Djaya.
            </Text>
            <Text fontSize="sm">Copyright © {year}. SUKANDA ONELINK</Text>
            <Text fontSize="sm">Version {pacakgeInfo.version}</Text>
          </VStack>
        </Stack>
      </PageContainer>
    </Box>
  );
}

export default Footer;
